import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactLazyload from 'react-lazyload'
import { ie11media } from '@blazar-plugins/device'

import { IconNoImage } from 'blocket-ui'

const Wrapper = styled.div`
  position: relative;
  background-color: #f9f7f6;
  width: 100%;
  height: 100%;
  border-radius: ${({ borderRadius }) => borderRadius};
`

export const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${({ objectFit }) => objectFit};
  border-radius: ${({ borderRadius }) => borderRadius};

  ${ie11media} {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
  }
`

const NoImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 1px solid #efefef;
  background-color: #fff;
  border-radius: ${({ borderRadius }) => borderRadius};
`

export const getLiImageSrcSet = (image) => {
  if (!image) {
    return ''
  }

  // These types are the images that correspons "best"
  // to the wanted images.
  // We want for small images 120, 240 and 360 width images
  // For medium images we want 180, 360 and 540 width images
  // to account for 1x 2x 3x pixel density
  // The types can be fetched using the `image_types` classefieds api
  return `
    ${image.url}?type=thumb 120w,
    ${image.url}?type=gallery_big 180w,
    ${image.url}?type=mob_iphone_vi_normal 240w,
    ${image.url}?type=store_presentation 360w,
    ${image.url}?type=mob_iphone_vi_normal_retina 540w,
  `
}
export const getLiImageSrc = (image) => {
  if (!image) {
    return ''
  }

  return `${image.url}?type=gallery_big`
}

export const ListImage = ({
  image,
  src,
  srcSet,
  alt,
  children,
  objectFit,
  borderRadius = '4px',
  noImageStyle,
  sizes,
  index,
}) => {
  let _src = src
  let _srcSet = srcSet
  let _objectFit = objectFit || 'cover'

  if (image) {
    _src = getLiImageSrc(image)
    _srcSet = getLiImageSrcSet(image)
    _objectFit = objectFit || 'contain'
  }

  let content

  if (_src) {
    content = (
      <StyledImg
        src={_src}
        srcSet={_srcSet}
        alt={alt}
        objectFit={_objectFit}
        borderRadius={borderRadius}
        sizes={sizes}
      />
    )
  } else {
    content = (
      <NoImageWrapper borderRadius={borderRadius} style={noImageStyle}>
        <IconNoImage width="60%" height="60%" color="#E1E1E1" />
      </NoImageWrapper>
    )
  }

  if (index > 12) {
    return (
      <Wrapper borderRadius={borderRadius}>
        <ReactLazyload once offset={100}>
          {content}
        </ReactLazyload>
        {children}
      </Wrapper>
    )
  }

  return (
    <Wrapper borderRadius={borderRadius}>
      {content}
      {children}
    </Wrapper>
  )
}

ListImage.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  src: PropTypes.string,
  alt: PropTypes.string,
  objectFit: PropTypes.string,
  children: PropTypes.node,
  borderRadius: PropTypes.string,
  noImageStyle: PropTypes.object,
  /**
   * https://developer.mozilla.org/en-US/docs/Learn/HTML/Multimedia_and_embedding/Responsive_images
   */
  srcSet: PropTypes.string,
  sizes: PropTypes.string,
  index: PropTypes.number,
}

export default ListImage
